import type { OrderChangeLog } from '@fitting-room/contracts'
import { boutiqueDateTime } from '../../../lib/boutique'
import { CHANGE_ACTION_LABEL, changeLogText } from '../../../lib/orders'

/**
 * The order's history, newest first. tperent's `ChangeLogList`: what was done,
 * by whom and when, the reason when one was asked for, and a line per field
 * that changed.
 */
export function ChangeLogList({ logs }: { readonly logs: readonly OrderChangeLog[] }) {
  if (logs.length === 0) return <p className="st-meta text-sm">Nothing yet.</p>
  return (
    <ol className="space-y-3.5" aria-label="Order history">
      {logs.map((log) => (
        <li key={log.id} className="border-l-2 pl-3" style={{ borderColor: 'var(--st-rule)' }} data-action={log.action}>
          <div className="st-meta flex flex-wrap items-center gap-x-1.5 gap-y-1 text-xs">
            <span className="st-badge st-order-log" data-action={log.action}>
              {CHANGE_ACTION_LABEL[log.action]}
            </span>
            <span>· {log.actorLabel ?? 'Someone'} ·</span>
            <time dateTime={log.createdAt} className="tabular-nums">
              {boutiqueDateTime(log.createdAt)}
            </time>
          </div>
          {log.reason ? <p className="mt-1.5 break-words text-sm">Reason: {log.reason}</p> : null}
          {log.changes.summary.length > 0 ? (
            <ul className="mt-1 space-y-0.5">
              {log.changes.summary.map((line, index) => (
                <li key={index} className="st-meta break-words text-xs">
                  {changeLogText(line)}
                </li>
              ))}
            </ul>
          ) : null}
        </li>
      ))}
    </ol>
  )
}
